import { toNumber, toPrecision } from '~shared/utils/number';
import { findResponse } from '~teacher/components/StudentScore/utils';
import { QuestionScore, Student } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { NormalizedResponse } from '../../util/normalizeResponses';
import { add } from '../add';
import { calculateStudentQuestionScore } from './calculateStudentQuestionScore';

export const calculateStudentQuizTotal = (
  student: Student,
  questions: QuizQuestion[],
  responses: NormalizedResponse,
  questionScores: Record<string, QuestionScore>
) => {
  const quizTotal = questions
    .map((question) => {
      const response = findResponse({
        responses: responses,
        studentId: student.id,
        questionId: question.questionId as number,
      });
      const questionScore: QuestionScore =
        (questionScores ?? {})[question.questionId] ?? null;
      const studentScore = questionScore?.studentScores[student.id] ?? null;
      return [question, response, questionScore, studentScore] as const;
    })
    .map(
      ([question, response, questionScore, studentScore]) =>
        calculateStudentQuestionScore(
          response,
          question,
          questionScore,
          studentScore
        ) ?? 0
    )
    .reduce(add, 0);
  return toNumber(toPrecision(quizTotal, 2));
};
